/**
 * The two things a project asks of its own AI, offered where the documentation is.
 *
 * This is the same pair as on the projects page, and it belongs here more than there: both of them
 * are *about* the documentation. SYNC brings the repository's writing into Vephus, and "% done"
 * asks an agent to read that writing against the code and say how much of it is built.
 *
 * The project is the one chosen at the top of the app (docs/refactor/51, D3) — no second picker with
 * the projects' keys here — and the pair sits folded under "Pedir para a sua IA", out of the way of
 * the documents until somebody wants it.
 */

import { useQuery } from '@tanstack/react-query'
import { MoreHorizontal } from 'lucide-react'
import { api } from '../lib/api'
import { useActiveRepository } from '../lib/activeRepository'
import { useI18n } from '../lib/i18n'
import { ProjectAgentActions } from './ProjectAgentActions'

export function DocsAgentActions() {
  const { t } = useI18n()
  const { data } = useQuery({ queryKey: ['specs', {}], queryFn: () => api.specs.list() })
  const { active } = useActiveRepository()

  const projects = data?.projects ?? []
  const chosen = projects.find((project) => project.id === active?.projectId) ?? projects[0]
  if (!chosen) return null

  return (
    <details className="docs__agent">
      <summary className="docs__agent-summary tiny">
        <MoreHorizontal size={13} aria-hidden /> {t('docs.agentFor', { project: chosen.name })}
      </summary>
      <div className="docs__agent-body">
        <ProjectAgentActions project={chosen} />
      </div>
    </details>
  )
}
